import {IReelListItem} from "../types/IReelListItem";
import {IReelSize} from "../types/IReelSize";

export const getListReelCoverImgBySize = (coverImgVariants: IReelListItem["cover"], size: IReelSize) => {
    return size === "S" ? coverImgVariants.r_r_img_168x300 : coverImgVariants.r_r_img_360x644;
};
import {IReelListItem} from "../types/IReelListItem";
import {IReelSize} from "../types/IReelSize";

export const getListReelCoverImgBySize = (coverImgVariants: IReelListItem["cover"], size: IReelSize) => {
    return size === "S" ? coverImgVariants.r_r_img_168x300 : coverImgVariants.r_r_img_360x644;
};
